import { PATH, PROFILE_PATH, GAME_PATH, MAIN_PATH } from './path';
export const LINKS = [
  {
    to: PATH.game,
    title: 'Мини-игры',
    id: 1,
  },
  {
    to: PATH.book,
    title: 'Учебник',
    id: 2,
  },
  {
    to: PATH.statistic,
    title: 'Статистика',
    id: 3,
  },
];

export const PROFILE = [
  { to: PROFILE_PATH.login, title: 'Вход' },
  { to: PROFILE_PATH.register, title: 'Регистрация' },
];

export const GAME = [
  {
    to: GAME_PATH.audio,
    title: 'Аудиовызов',
    img: 'image/audio.svg',
    text: 'Вы прослушиваете слово на английском языке и выбираете из пяти предложенных вариантов ответа верный',
  },
  {
    to: GAME_PATH.sprint,
    title: 'Спринт',
    img: 'image/sprint.svg',
    text: 'Выбирайте верные варианты ответа на скорость',
  },
];

export const MAIN_ITEMS = [
  {
    to: MAIN_PATH.textbook,
    title: 'Учебник',
    img: 'image/textbook.svg',
    text: `Электронный учебник состоит из 6 разделов. В каждом 30 страниц по 20 слов.
    Представлены перевод слова, тематическое изображение, а также произношение как
    слова отдельно, так и в составе словосочетания.`,
  },
  {
    to: MAIN_PATH.game,
    title: 'Мини-игры',
    img: 'image/games.svg',
    text: `Для изучения слов и закрепления запоминания в приложении есть 2 игры: Sprint,
    Audio Chalenge, которые помогут вам в игровой форме «прокачать» словарный запас.`,
  },
  {
    to: MAIN_PATH.statistic,
    title: 'Статистика',
    img: 'image/stats.svg',
    text: `Весь прогресс обучения можно посмотреть в статистике, где представлены данные
    как за текущий день, так и за весь период обучения.`,
  },
];
